export const PC_PAGE_CONFIG = {
  name: 'CommonHeader',
  config: {
    title: 'PC/Console Genre & Region Benchmark',
    titleCn: '端游/主机游戏 品类 & 国家基准数据',
    operationList: {
      name: 'OperationTitle',
      config: {
        title: 'For any questions, contact sallyxue@tencent.com.',
        titleCn: '如有问题，请联系sallyxue@tencent.com。',
      },
    },
  },
  children: [
    {
      name: 'CommonContantWrap',
      config: {
        logConfig: {
          typeId: 'benchmark_pc_console',
          uid: "",
          uidType: "",
          pageId: '800201',
          pageName: 'PC/Console Genre & Region Benchmark',
          extInfo: {},
          pagePath: '/benchmark/pcconsole/genre',
        },
      },
      children: [
        {
          name: 'BenchmarkFilter',
          isOpenSticky: false,
          isHaveFilterSave: false,
          filterPath: '/genre',
          props: {
            defaultMetricList: [
              'sales_y',
              'revenue_y',
              'revenue_ratio_wy',
              'sales_ratio_wy',
              'steam_pcu',
              'main_story_playtime'
            ],
          },
          children: [
            {
              name: 'MetricTableService',
              className: '',
              type: 'layout',
              style: {
                marginTop: '20px',
              },
              props: {
                api: '/api/v2/dashboard/benchmark/metric',
              },
              children: [
                {
                  name: 'MetricConfig',
                  className: '',
                  props: {},
                  children: [
                    {
                      name: 'MetricTable',
                      className: '',
                      type: 'layout',
                      style: {
                        marginTop: '10px',
                      },
                      props: {
                        firstColumnNameList: [
                          {
                            nameEn: 'Top 10%',
                            nameCn: '前 10%',
                            value: 'top10per',
                          },
                          {
                            nameEn: 'Median',
                            nameCn: '中位数',
                            value: 'median',
                          },
                        ],
                      },
                    },
                  ],
                },
              ],
            },
            {
              name: 'TabsAndRadio',
              className: '',
              type: 'layout',
              style: {},
              props: {
                logConfig: {
                  buttonId: '800201001',
                  pageId: '800201',
                  typeId: 'benchmark_pc_console',
                },
                radioOptions: {
                  options: [
                    {
                      value: 'top10per',
                      textEn: 'Top 10%',
                      textCn: '前 10%',
                    },
                    {
                      value: 'median',
                      textEn: 'Median',
                      textCn: '中位数',
                    },
                  ],
                  defaultValue: 'median',
                },
                tabsOptions: {
                  options: [
                    {
                      value: 'game',
                      text: { textEn: 'Game', textCn: '游戏' },
                      info: {
                        textEn:
                          'Benchmark data comes from anonymized Tencent projects and external sources. The following game list shows only external data.',
                        textCn:
                          'Benchmark数据由腾讯真实项目脱敏数据和外部多方数据源得出，如下游戏列表仅展示外部数据源游戏项目数据',
                      },
                    },
                    {
                      value: 'country',
                      text: { textEn: 'Country', textCn: '国家' },
                    },
                    {
                      value: 'platform',
                      text: {
                        textEn: 'Platform',
                        textCn: '平台',
                      },
                    },
                  ],
                  style: { marginTop: '18px' },
                  hideAfterNodeByTabKeys: ['game'],
                },
              },
              children: [
                {
                  name: 'GenreTableService',
                  className: '',
                  type: 'layout',
                  style: {},
                  props: {},
                  children: [
                    {
                      name: 'BenchMarkTable',
                      className: '',
                      type: 'layout',
                      style: {
                        marginTop: '18px',
                      },
                      props: {
                        dimColumnWidth: 264,
                        dimColumnFixed: 'left',
                        radioValueKey: 'value_type',
                        config: {
                          api: {
                            tableApi:
                              '/api/v2/dashboard/benchmark/overall_performance',
                            tableDownloadApi:
                              '/api/v2/dashboard/benchmark/overall_performance/download',
                          },
                          downConfig: {
                            customDownNameEn: 'Genre&Region Benchmark',
                            customDownNameCn: '品类 & 国家基准数据',
                            defaultFileType: 'excel',
                          },
                          customColumnsBeforeDim: [
                            {
                              columnKey: 'release_time',
                              valueKeyEn: 'release_time',
                              valueKeyCn: 'release_time',
                              nameEn: 'Release Date',
                              nameCn: '发布日期',
                              fixed: 'left',
                              enWidth: 180,
                              cnWidth: 180,
                              showTabs: ['game'],
                              formatRule: 'YYYY-MM-DD'
                            },
                            {
                              columnKey: 'genre',
                              valueKeyEn: 'game_genre',
                              valueKeyCn: 'game_genre_cn',
                              nameEn: 'Genre',
                              nameCn: '品类',
                              enWidth: 140,
                              cnWidth: 160,
                              sorter: false,
                              fixed: 'left',
                              showTabs: ['game'],
                              tooltipEn:
                                'The IEGG genre tags for mobile games is the result of a comprehensive review by Game Research Center experts of the data available in the database.The IEGG genre tags for PC games are provided by Game Research Center reviewers based on Steam Tags，while the genre tags for Console games are provided by Game Research Center reviewers based on the Steam Tags for the PC game of the same name and reference to Pioc Pixels.',
                              tooltipCn:
                                '手游的IEGG品类标签是Game Research Center专家综合数据库可用的数据进行综合评测提供的，PC游戏的IEGG品类标签是Game Research Center的评测专家根据Steam Tags提供的，而Console游戏的IEGG品类标签是Game Research Center的评测专家根据同名PC游戏的Steam Tags以及参考Pioc Pixels提供的。',
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
